<template>
  <div class="aa-return-policy">
    <v-container>
      <div class="aa-return-policy__wrap">
        <h1>Return Policy</h1>
        <div v-if="this.field" v-html="this.field.content"></div>
      </div>
    </v-container>
  </div>
</template>

<script>
import ReturnPolicy from "@/services/ReturnPolicy.js";

export default {
  data: () => {
    return {
      field: null,
    };
  },
  created: async function() {
    this.field = await ReturnPolicy.getReturnPolicyField();

    if (this.field) {
      this.$store.dispatch("loader/showLoader", {
        loading: false,
      });
    }
  },
};
</script>

<style lang="scss">
@import "./style-return-policy.scss";
</style>
